import { ROLES_LIST } from '@/js/constants';
export default [{
  name: 'Dashboard',
  icon: '"mdi mdi-robot-happy',
  key: 'menu.ch.chatbots',
  href: {
    name: 'Chatbots'
  },
  link: '/Chatbots/Dashboard',
  regex: /^\/Chatbots/,
  subItems: [/* Dashboard */
  {
    name: 'Dashboard',
    icon: '"mdi mdi-tablet-dashboard',
    key: 'menu.ch.dashboard_management',
    href: {
      name: 'Dashboard'
    },
    link: '/Chatbots/Dashboard',
    check_flag: ''
  },
  /*{
    name: 'Centro de Datos',
    icon: 'mdi-database-cog-outline',
    key: 'menu.ch.data_center',
    href: { name: 'DataCenter' },
    link: '/Chatbots/DataCenter',
    roles: [ROLES_LIST.ML_DEVELOPER, ROLES_LIST.ML_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    check_flag: ''
   },*/
  {
    name: 'Gestión de Proyectos',
    icon: 'mdi-forum-outline',
    key: 'menu.ch.agent_management',
    href: {
      name: 'ProjectManagement'
    },
    link: '/Chatbots/ProjectManagement',
    roles: [ROLES_LIST.ML_DEVELOPER, ROLES_LIST.ML_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    check_flag: ''
  }, {
    name: 'Gestión de BOTS',
    icon: 'mdi-robot-happy',
    key: 'menu.ch.bot_management',
    href: {
      name: 'BotsManagement'
    },
    link: '/Chatbots/BotsManagement',
    roles: [ROLES_LIST.ML_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    check_flag: '',
    checkDomain: true
  }, {
    name: 'Configuración',
    icon: 'icon-config',
    key: 'menu.ch.config',
    href: {
      name: 'ChatbotConfig'
    },
    link: '/Chatbots/ChatbotConfig',
    roles: [ROLES_LIST.ML_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    check_flag: '',
    checkDomain: true
  }
  /*{
    name: 'Channel Management',
    icon: '"mdi mdi-animation',
    key: 'menu.ch.channel_management',
    href: { name: 'ChannelManagement' },
    link: '/Chatbots/ChannelManagement',
    roles: [ROLES_LIST.ML_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    check_flag: '',
    checkDomain: true,
  },*/

  /* Search Engine */
  /*{
    name: 'Search Engine',
    icon: '"mdi mdi-search-web',
    key: 'menu.ch.search_engine',
    href: { name: 'SearchEngine' },
    link: '/Chatbots/SearchEngine',
    check_flag: '',
    checkDomain: true
  }*/
  /*   {
      name: 'Gestión de usuarios-permisos',
      icon: '',
      key: 'menu.ch.userpermission_management',
      href: { name: 'ChatbotsUserPermissionManagement' },
      link: '/Chatbots/UserPermissionManagement',
      check_flag: ''
    } */]
}];